import React from 'react';
import PropTypes from 'prop-types';

import Logo from './Logo';
import Buttons from './Buttons';

const HeaderBaseComponent = props => (
  <header>
    <div className="header-main">
      <Logo />
      <Buttons />
    </div>

    <div className="header-nav">
      {props.children}
    </div>
  </header>
);

HeaderBaseComponent.propTypes = {
  children: PropTypes.node.isRequired
};

export default HeaderBaseComponent;
